import { useEffect } from "react";
import { Platform } from "react-native";

const DEFAULT_WORKSPACE_TITLE = "Findify";

export const makeSeoTitle = (pageTitle?: string | null, workspaceTitle = DEFAULT_WORKSPACE_TITLE) => {
    const cleanPageTitle = `${pageTitle ?? ''}`.replace(/\s+/g, ' ').trim();
    const cleanWorkspaceTitle = `${workspaceTitle || DEFAULT_WORKSPACE_TITLE}`.replace(/\s+/g, ' ').trim();

    if (!cleanPageTitle) return cleanWorkspaceTitle;
    if (cleanPageTitle.toLocaleLowerCase().includes(cleanWorkspaceTitle.toLocaleLowerCase())) return cleanPageTitle;
    return `${cleanPageTitle} | ${cleanWorkspaceTitle}`;
}

export const setSeoTitle = (pageTitle?: string | null, workspaceTitle = DEFAULT_WORKSPACE_TITLE) => {
    if (Platform.OS !== 'web' || typeof document === 'undefined') return;
    document.title = makeSeoTitle(pageTitle, workspaceTitle);
}

export const useSeoTitle = (pageTitle?: string | null, workspaceTitle = DEFAULT_WORKSPACE_TITLE) => {
    useEffect(() => {
        setSeoTitle(pageTitle, workspaceTitle);
    }, [pageTitle, workspaceTitle]);
}
